export default __webpack_public_path__ + "021d6e4e6fcfd81c804d6dbf41e8e17f.png";